import React from 'react';
import { Loader, Center } from '@mantine/core';

interface LoadingSpinnerProps {
  size : string;
  color : string;
  h? : string;
}

function LoadingSpinner({size, color, h} : LoadingSpinnerProps) {
  return (
    <Center style={h ? { height: h } : {height : "100vh"}}>
      <Loader color={color} size={size} variant="dots" />
    </Center>
  );
}

export default LoadingSpinner;